export default "https://cdn.cloudgame.qcloud.com/static/sg/prod/dist/img/dialog_cover_en.08ec3ca3122268a7c7288afe888401d9.png";